import React, { useState } from 'react';
import { dispatch } from 'nike-re-framejs';

import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { Button } from 'nike-ui/src/components/button/Button';
import { reportPost } from '@/betbook/handlers';

function BetbookPostReportDialog({ postType, postId }) {
    const [text, setText] = useState('');
    function sendReport() {
        dispatch(reportPost(postType, postId, text));
        PopupNg.dispatcher.closeAll();
    }

    return (
        <Docked>
            <DialogTitle>
                <h2 className="betbook-report-dialog">{i18n('betbook.post.report')}</h2>
            </DialogTitle>
            <DialogBody>
                <div className="nike-form">
                    <label className="nike-input">
                        <div className="nike-input-label">{i18n('betbook.post.reportReason')}</div>
                        <textarea
                            data-atid="input-text"
                            value={text}
                            onChange={e => setText(e.target.value)}
                            placeholder={i18n('tiket.detailTiketu.reklamacia.option.text.default')}
                            rows="3"
                        />
                    </label>
                    <label className="nike-input">
                        <Button
                            type="submit"
                            disabled={text.length < 5}
                            onClick={sendReport}
                            label={i18n('contactus.label.action')}
                        />
                    </label>
                </div>
            </DialogBody>
        </Docked>
    );
}

export default BetbookPostReportDialog;
